import { SelectedAccountUserGroup } from '../../../../../generated';
import type { TypePolicies } from '../../../../../utils/types/TypePolicies';
import { readEntityCacheFragmentById } from '../../utils/typePolicyUtils';

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      selectedAccountUserGroups: {
        read: (_existing, { cache, args }) =>
          args.accountUserGroupIds.map((id: any) =>
            readEntityCacheFragmentById({
              cache,
              fragment: SelectedAccountUserGroup,
              fragmentName: 'SelectedAccountUserGroup',
              selector: {
                id,
                __typename: 'AccountUserGroup',
              },
            })
          ),
      },
    },
  },
};
